import { useMemo } from 'react'
import { orderBy } from 'lodash'

import { FormTabsPanelResponse } from '@tabeeb/contracts/main-api/swagger-main-api'
import { useDispatch, useSelector } from '@tabeeb/store'
import { ElementRenderer, useFormContext } from '@collaborate-health/forms'
import { Stack } from '@collaborate-health/uikit'

import { getSelectedTabs } from '../../selectors'
import { setCurrentTabs } from '../../actions'

import { StyledTab, StyledTabs } from './FormTabPanel.styles'

const FormTabPanel: React.FC<ElementRenderer<'tabs', FormTabsPanelResponse>> = ({ element, children }) => {
  const dispatch = useDispatch()
  const selectedTabs = useSelector(getSelectedTabs)
  const { form } = useFormContext()

  const panelIndex = useMemo(
    () =>
      orderBy(
        form.elements.filter((e) => e.elementType === 'tabs'),
        (e) => e.order
      ).findIndex((e) => e.id === element.id),
    [element.id, form.elements]
  )

  const panel = element.meta
  if (!panel?.Tabs?.length) {
    return null
  }

  return (
    <Stack position='relative'>
      <StyledTabs
        value={selectedTabs[panelIndex] || false}
        variant='fullWidth'
        onChange={(e: React.ChangeEvent<{}>, tabId: number) => {
          const updatedSelectedTabs = [...selectedTabs]
          updatedSelectedTabs[panelIndex] = tabId

          dispatch(setCurrentTabs(updatedSelectedTabs))
        }}
      >
        {panel.Tabs.map((tab) => (
          <StyledTab key={tab.Order} value={tab.Id} title={tab.Value!} label={tab.Value} />
        ))}
      </StyledTabs>
      {children}
    </Stack>
  )
}

export default FormTabPanel

